import React from "react";

const WorkHistory = ({ players, history }) => {
  return (
    <>
      <h5 className="font-header font-semibold text-front text-sm uppercase mt-12 mb-3 text-center">
        Game history
      </h5>
      <div className="history flex flex-col relative pt-6 pb-6">
        {history.map(({ date, time, player1, player2 }, i) => (
          <div className="history-entry relative w-1/2 py-4" key={i}>
            <span className="dot-bg w-14 h-14 absolute bg-line inline-flex rounded-full items-center justify-center">
              <span className="dot w-5 h-5 bg-back-light rounded-full" />
            </span>
            <h4 className="subpixel-antialiased">
              <p className="hover:opacity-75 transition-opacity duration-150">
                {player1 > player2
                  ? players.player1.name
                  : players.player2.name}{" "}
                wins{" "}
                {player1 > player2
                  ? `${player1}/${player2}`
                  : `${player2}/${player1}`}
              </p>
            </h4>
            <h5 className="text-sm font-normal mb-1">
              +{Math.abs(player1 - player2)} points
            </h5>
            <span className="text-sm font-medium opacity-50">
              {date}, {time}
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

export default WorkHistory;
